/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProposalDataLossViewModel
 */
export interface ProposalDataLossViewModel {
    /**
     * 
     * @type {string}
     * @memberof ProposalDataLossViewModel
     */
    affectedSteps: string;
    /**
     * 
     * @type {boolean}
     * @memberof ProposalDataLossViewModel
     */
    willSaveCauseDataLoss: boolean;
}

/**
 * Check if a given object implements the ProposalDataLossViewModel interface.
 */
export function instanceOfProposalDataLossViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "affectedSteps" in value;
    isInstance = isInstance && "willSaveCauseDataLoss" in value;

    return isInstance;
}

export function ProposalDataLossViewModelFromJSON(json: any): ProposalDataLossViewModel {
    return ProposalDataLossViewModelFromJSONTyped(json, false);
}

export function ProposalDataLossViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProposalDataLossViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'affectedSteps': json['AffectedSteps'],
        'willSaveCauseDataLoss': json['WillSaveCauseDataLoss'],
    };
}

export function ProposalDataLossViewModelToJSON(value?: ProposalDataLossViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'AffectedSteps': value.affectedSteps,
        'WillSaveCauseDataLoss': value.willSaveCauseDataLoss,
    };
}

